<!--<div class="checkout-error" *ngIf="error; else steps">
  {{ error | json }}
</div>-->
<ng-container *ngTemplateOutlet="steps"></ng-container>

<ng-template #steps>
  <ng-template #indicator></ng-template>

  <div class="gung-stepper-indicator-offset"></div>

  <span [hidden]="showLoading" class="checkout-step">
    <ng-template #step libCustomHost></ng-template>
  </span>

  <div *ngIf="!isSubmitted" class="container checkout-step-bottom-buttons-container p-3">
    <div class="checkout-step-bottom-buttons">
      <ng-template #btns></ng-template>
    </div>
  </div>

  <div *ngIf="showLoading && isSubmitting" class="progress mt-10">
    <div
      class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
      role="progressbar"
      aria-valuenow="75"
      aria-valuemin="0"
      aria-valuemax="100"
      style="width: 75%"
    ></div>
  </div>
  <div *ngIf="showLoading && isSubmitting">
    <h2 translate>SUBMITTING_WORKING_ORDER</h2>
  </div>

  <div *ngIf="isSubmitted" class="d-flex flex-column align-items-center justify-content-center bg-white p-5">
    <i *ngIf="!hasErrors" class="fa-light fa-circle-check fa-7x"></i>
    <i *ngIf="hasErrors" class="fa-light fa-circle-xmark fa-7x"></i>
    <h3 class="mt-4">{{ hasErrors ? error : ('WORK_SUBMITTED_SUCCESSFULLY' | translate) }}</h3>
    <h5 class="mt-4" *ngIf="hasErrors" translate>SUBMIT_WORK_ORDER_ANYWAY</h5>

    <button *ngIf="hasErrors" class="btn btn-outline-primary mt-4" (click)="goBackToTireStep()" translate>
      GO_BACK
    </button>
    <button
      *ngIf="hasErrors"
      class="btn btn-outline-primary mt-4"
      (click)="createWorkOrderIgnoreTirePolicy()"
      translate
    >
      SUBMIT_ANYWAY
    </button>
  </div>
</ng-template>
